/// <reference types="vitest" />

import { ICurrencyConversionService, ILocalizedContentService } from '@studyportals/portal-localized-content';
import { ICopilotServiceApplication } from '@studyportals/copilot-service-interfaces';
let localizedContentService!: ILocalizedContentService;
let currencyConversionService!: ICurrencyConversionService;
let copilotService!: ICopilotServiceApplication;

export default {
	currencyConversionService,
	localizedContentService,
	copilotService,
};
